import styled from 'styled-components';
import NavLink from '../link';

const StyledNavLink = styled(NavLink).attrs({ state: { via: 'CoverChildLink' } })`
  display: block;
  color: white;
  text-decoration: none;
  padding: .5rem ${({ theme }) => theme.grid.containerGap};
  &:first-child {
    padding-top: 0;
  }
  &:hover,
  &.${({ activeClassName }) => activeClassName} {
    color: ${({ theme }) => theme.primaryColor};
    background-color: transparent;
  }
`;

export default StyledNavLink;
